export function afterStore(controller) {
  controller.on("init", async ({ controller }, next) => {
    controller.log.debug("initialization...");
    await next();
  });
  controller.on("afterStore", async ({ controller: { store } }, next) => {
    await next();
  });
}